import "./Comentarios.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CargandoSpinner from "../0. Utilidades/loadingSpinner"; // Import the spinner component

function Comments() {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleRowClick = (rut) => {
    navigate(`/maestras/${rut}`);
  };

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/tabla/comentarios_semana/`;
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        setComments(data);
      } catch (error) {
        console.error("Failed to fetch recent comments", error);
      } finally {
        setLoading(false); // Stop loading after success or error
      }
    };

    fetchComments();
  }, []);

  return (
    <div id="comments-section">
      <div className="comments-header">Comentarios Última Semana</div>

      {loading ? (
        <CargandoSpinner /> // Show spinner while loading
      ) : (
        <div className="comments-container">
          {comments.map((comment) => (
            <div
              className="comment-card"
              key={comment.id}
              onClick={() => handleRowClick(comment.maestra)}
            >
              <div className="comment-image-container">
                <img
                  src={
                    comment.maestra_imagen ||
                    "https://cdn-redmaestra-endpoint.azureedge.net/static/images/default.png"
                  }
                  alt="Profile"
                />
              </div>
              <div className="comment-content">
                <div className="comment-text">{comment.comment_text}</div>
                <div className="comment-timestamp">
                  ✔️✔️ {comment.timestamp}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Comments;
